import { CategoryChipProps } from '@/renderer/types/sales';
import React from 'react';

export const CategoryChip: React.FC<CategoryChipProps> = ({
  label,
  isActive,
  onClick,
}) => {
  return (
    <button
      type="button"
      className={`flex h-full min-h-[48px] w-full items-center justify-center border-b border-r border-gray-200 px-2 text-center text-sm uppercase tracking-[0.03em] transition-colors ${
        isActive ? 'app-bg' : 'bg-white hover:app-bg'
      }`}
      onClick={onClick}
    >
      <span className="line-clamp-2 break-words px-1 text-center leading-tight">
        {label}
      </span>
    </button>
  );
};
